import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { queryRoots } from '../../lib/events';

/** The GDPR deletion request of an approval (docs/dev/api-gdpr.md „Routes"). */

export type GdprRequestStatus = 'open' | 'reviewed' | 'deleted' | 'rejected';

export interface GdprRequestView {
  id: string;
  status: GdprRequestStatus;
  statusLabel: 'offen' | 'freigegeben' | 'gelöscht' | 'abgelehnt';
  contact: { id: string; name: string };
  requestedAt: string;
  requestedBy: { id: string; name: string } | null;
  preview: {
    deletes: { label: string; count: number }[];
    pseudonymizes: { label: string; count: number }[];
    keeps: string[];
  };
  executedAt: string | null;
  log: string | null;
}

/** Under the approvals root: `approval.decided` and the dialog's own invalidation refresh it. */
export const gdprRequestKey = (approvalId: string) => [...queryRoots.approvals, 'gdpr', approvalId] as const;

/** `GET /gdpr-requests?approvalId=`; polls while the approved deletion waits for the minutely job. */
export function useGdprRequest(approvalId: string) {
  return useQuery({
    queryKey: gdprRequestKey(approvalId),
    queryFn: ({ signal }) =>
      api<GdprRequestView>(`/gdpr-requests?approvalId=${encodeURIComponent(approvalId)}`, { signal }),
    refetchInterval: (query) => (query.state.data?.status === 'reviewed' ? 10_000 : false),
  });
}

/** „Löschung erneut ausführen" (admin, `reviewed` only). */
export function executeGdprRequest(id: string): Promise<GdprRequestView> {
  return api<GdprRequestView>(`/gdpr-requests/${id}/execute`, { method: 'POST', body: {} });
}
